<script>
import DashTip from "./DashTip";
import { CYCLES, fmtNum } from "@/data/dashboardModel";

// Siguientes acciones: ítems pendientes de mayor peso (ordenados en el modelo por `value` desc).
// Cada fila es un enlace a Estándares; hover y foco muestran la descripción completa.
export default {
  name: "NextActions",
  components: { DashTip },
  props: {
    items: { type: Array, default: () => [] },
    to: { type: [String, Object], default: "/forms/estandares" },
  },
  data() {
    return { active: -1, tip: { x: 0, y: 0 } };
  },
  methods: {
    fmtNum,
    cls(s) {
      return "dsh-st--" + s.toLowerCase().replace(/\s+/g, "-");
    },
    cycle(i) {
      const c = CYCLES.find((x) => x.key === i.cycle);
      return c ? c.label : "";
    },
    show(i, ev) {
      this.active = i;
      const host = this.$refs.host;
      const row = ev.currentTarget || ev.target;
      if (!host || !row) return;
      const hr = host.getBoundingClientRect();
      const rr = row.getBoundingClientRect();
      this.tip = { x: Math.min(rr.left - hr.left + 120, hr.width - 130), y: rr.top - hr.top + 4 };
    },
    hide(i) {
      if (this.active === i) this.active = -1;
    },
  },
};
</script>

<template>
  <div ref="host" class="dsh-next">
    <ol class="dsh-next__list">
      <li v-for="(it, i) in items" :key="it.id">
        <router-link
          :to="to"
          class="dsh-next__row"
          :class="{ 'is-active': active === i }"
          :aria-label="`${it.sequence} ${it.description}. ${it.status}. Suma ${fmtNum(it.value)} puntos.`"
          @mouseenter.native="show(i, $event)"
          @mouseleave.native="hide(i)"
          @focus.native="show(i, $event)"
          @blur.native="hide(i)"
        >
          <span class="dsh-next__seq">{{ it.sequence }}</span>
          <span class="dsh-next__body">
            <span class="dsh-next__desc">{{ it.description }}</span>
            <small class="dsh-next__meta">
              <span class="dsh-sw" :class="cls(it.status)"></span>{{ it.status }} · {{ cycle(it) }}
            </small>
          </span>
          <span class="dsh-next__pts">+{{ fmtNum(it.value) }}<small>pts</small></span>
        </router-link>
      </li>
    </ol>
    <DashTip :show="active > -1" :x="tip.x" :y="tip.y">
      <template v-if="active > -1">
        <div class="dsh-tip__head">{{ items[active].sequence }} · {{ cycle(items[active]) }}</div>
        <div class="dsh-tip__desc">{{ items[active].description }}</div>
        <div class="dsh-tip__row dsh-tip__row--key">
          <span class="dsh-sw" :class="cls(items[active].status)"></span>
          <strong>{{ items[active].status }}</strong>
          <span>· suma {{ fmtNum(items[active].value) }} {{ items[active].value === 1 ? "punto" : "puntos" }}</span>
        </div>
      </template>
    </DashTip>
  </div>
</template>
